module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['component-wrapper',
      {
        'is-hidden': _vm.indexHidden
      }
    ],
    attrs: {
      "id": "cw"
    }
  }, [_c('div', {
    staticClass: "index-portrait"
  }), _vm._v(" "), _c('section', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "branding"
  }, [_c('div', {
    staticClass: "index-logo"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 116 94"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12,0,0,4.1,4,16l12.25-3.833Z",
      "fill": "#2d2d2d"
    }
  }), _c('path', {
    attrs: {
      "d": "M4,16l5,4,11.141-3.5L15.95,11.938Z",
      "fill": "#212121"
    }
  }), _c('path', {
    attrs: {
      "d": "M20,16.5,16.9,6l-5-6,4,12Z",
      "fill": "#141414"
    }
  }), _c('path', {
    attrs: {
      "d": "M32,7,20,8,35.133,23.617,46,19.8Z",
      "fill": "#4b4b4b"
    }
  }), _c('path', {
    attrs: {
      "d": "M46,19.8l-8,13-11,5,7.9-14.77Z",
      "fill": "#343434"
    }
  }), _c('path', {
    attrs: {
      "d": "M13,24,20,8,35,23,27,37.8Z",
      "fill": "#656565"
    }
  }), _c('path', {
    attrs: {
      "d": "M50,19,30,34l14,6L66,23Z",
      "fill": "#bbb"
    }
  }), _c('path', {
    attrs: {
      "d": "M56,61,44,40,30,34,41,53Z",
      "fill": "#cacaca"
    }
  }), _c('path', {
    attrs: {
      "d": "M56,61,73,46,66,23,44,40Z",
      "fill": "#9a9a9a"
    }
  }), _c('path', {
    attrs: {
      "d": "M86,32l6,37L56,84l1-32Z",
      "fill": "#f4f4f4"
    }
  }), _c('path', {
    attrs: {
      "d": "M92,69l24,15L82,94,56,84Z",
      "fill": "#dbdad9"
    }
  }), _c('path', {
    attrs: {
      "d": "M92,69,86,32l21,20,9,32Z",
      "fill": "#c1c1c1"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "nav-social"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.emitJump()
      }
    }
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-about"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("About")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/pascalaoms",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-gh"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("GitHub")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://facebook.com/pascal.aoms",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-fb"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Facebook")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "mailto:email@artofmyself.com"
    }
  }, [_c('svg', [_c('use', {
    attrs: {
      "xlink:href": "#icon-mail"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("E-Mail")])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "portfolio-web"
    }
  }, [_c('portfolio-web')], 1), _vm._v(" "), _c('about-me'), _vm._v(" "), _c('portfolio-graphics')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Pascal Klau"), _c('br'), _vm._v(" "), _c('small', [_vm._v("Web Design")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82b7485c"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Index.vue
// module id = 96
// module chunks = 0